import { getEntry } from "../lib/content.server.js";
import { buildMeta } from "../lib/seo.js";
import Prose from "../components/Prose/Prose.jsx";

export async function loader() {
  const page = getEntry("pages", "sms-terms");
  if (!page) throw new Response("Not Found", { status: 404 });
  return { page };
}

export function meta() {
  return buildMeta({
    title: "SMS Terms & Conditions",
    description:
      "Terms for the sign-in and password-reset codes RDV Systems sends by text message to users of its web platform.",
    path: "/sms-terms",
  });
}

export default function SmsTerms({ loaderData }) {
  return (
    <section className="section">
      <div className="container">
        <h1>SMS Terms &amp; Conditions</h1>
        <p className="lead">Last updated {loaderData.page.updated || loaderData.page.date}.</p>
        <Prose html={loaderData.page.html} />
      </div>
    </section>
  );
}
